<template>
  <div>
    <a-form :form="form.fc" v-bind="formItemLayout">
      <!-- <a-row :gutter="20">
        <a-col :span="11">
          <a-form-item :label="$t('scope.text_70')">
            <base-select
              :remote="true"
              needParams
              :params="{ 'cloud_env': 'private_or_onpremise', 'brand': 'OneCloud' }"
              v-decorator="decorators.region"
              resource="cloudregions"
              :remote-fn="q => ({ search: q })"
              :select-props="{ placeholder: $t('scope.text_71') }" />
          </a-form-item>
        </a-col>
      </a-row> -->
      <a-spin :spinning="zonesLoading" style="min-width: 600px">
        <a-row :gutter="20" :key="k"  v-for="k in form.fc.getFieldValue('keys')">
           <a-col :span="8">
             <a-form-item :label="$t('scope.text_70')">
                <a-select v-decorator="[`${k}.region`, {
                  ...options.region,
                  initialValue: (zones && zones[k]) ? zones[k].region_id : undefined
                }]" :placeholder="$t('scope.text_72')">
                  <a-select-option v-for="item in cloudregions" :value="item.id" :key="item.id">
                    {{item.name}}
                  </a-select-option>
                </a-select>
             </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('scope.text_21')">
              <a-input v-decorator="[`${k}.name`, {
                ...options.name,
                initialValue: (zones && zones[k]) ? zones[k].name : undefined
              }]" :placeholder="$t('scope.text_38')" />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item :label="$t('scope.text_54')">
              <a-input v-decorator="[`${k}.description`, {
                initialValue: (zones && zones[k]) ? zones[k].description : undefined
              }]" :placeholder="$t('scope.text_55')" />
            </a-form-item>
          </a-col>
          <a-col :span="1" v-if="form.fc.getFieldValue('keys').length > 1">
            <a-button @click="handleRemove(k)" shape="circle" icon="minus" size="small" class="mt-2 ml-2" />
          </a-col>
          <a-col :span="24">
            <a-divider class="mt-1" />
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="11">
            <a-form-item v-bind="offsetFormItemLayout">
                <a-button type="dashed" style="width: 50%" @click="handleAdd">
                  <a-icon type="plus" />{{$t('scope.text_73')}}</a-button>
              </a-form-item>
          </a-col>
        </a-row>
      </a-spin>
    </a-form>
  </div>
</template>

<script>
import { getRequestT } from '@/utils/utils'

export default {
  name: 'GuideZone',
  inject: ['formItemLayout', 'offsetFormItemLayout', 'tempData'],
  data () {
    return {
      loading: false,
      region: {},
      zones: {},
      zonesLoading: false,
      cloudregions: [],
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        region: ['region', {
          initialValue: 'default',
          rules: [
            { required: true, message: this.$t('scope.text_72') },
          ],
        }],
      },
      options: {
        name: {
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_38') },
            // { validator: this.$validate('resourceName') },
          ],
        },
        region: {
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_72') },
          ],
        },
      },
    }
  },
  computed: {
    setupKeys () {
      if (this.$store.state.globalSetting && this.$store.state.globalSetting.value) {
        return this.$store.state.globalSetting.value.setupKeys || []
      }
      return []
    },
  },
  created () {
    this.form.fc.getFieldDecorator('keys', {
      initialValue: [new Date().valueOf()],
      preserve: true,
    })
    this.manager = new this.$Manager('zones')
    this.queryFetchZones()
    this.queryCloudregions()
  },
  methods: {
    async queryCloudregions () {
      try {
        const { data = {} } = await new this.$Manager('cloudregions').list({
          params: {
            limit: 0,
            cloud_env: 'private_or_onpremise',
            brand: 'OneCloud',
            scope: this.$store.getters.scope,
          },
        })
        this.cloudregions = data.data || []
      } catch (err) {
        throw err
      }
    },
    handleAdd () {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      const nextKeys = keys.concat(new Date().valueOf())
      fc.setFieldsValue({
        keys: nextKeys,
      })
    },
    handleRemove (k) {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      fc.setFieldsValue({
        keys: keys.filter(_ => _ !== k),
      })
    },
    async queryFetchZones () {
      if (!this.setupKeys || this.setupKeys.length === 0) return false
      this.zonesLoading = true
      try {
        const { data = {} } = await this.manager.list({
          params: {
            limit: 0,
            scope: this.$store.getters.scope,
            brand: 'OneCloud',
          },
        })
        const ids = []
        const zones = data.data || []
        if (zones && zones.length > 0) {
          zones.forEach(item => {
            const { id } = item
            ids.push(id)
            this.zones[id] = item
          })
        }
        if (ids && ids.length > 0) {
          const { fc } = this.form
          fc.setFieldsValue({
            keys: ids,
          })
        }
      } catch (err) {
        throw err
      } finally {
        this.zonesLoading = false
      }
    },
    async doSubmit () {
      try {
        const { region, ...values } = await this.form.fc.validateFields()
        delete values.keys
        const promises = []
        for (const k in values) {
          const params = {
            region: values[k].region,
            name: values[k].name,
            description: values[k].description,
          }
          promises.push(new Promise((resolve, reject) => {
            if (this.zones && this.zones[k]) {
              this.manager.update({
                id: k,
                data: params,
                params: { $t: getRequestT() },
              }).then(({ data }) => {
                resolve(data)
              }).catch(err => {
                reject(err)
              })
            } else {
              this.manager.create({
                data: params,
                params: { $t: getRequestT() },
              }).then(({ data }) => {
                resolve(data)
              }).catch(err => {
                reject(err)
              })
            }
          }))
        }
        const zones = await Promise.all(promises)
        return ['zone', zones]
      } catch (err) {
        throw err
      }
    },
  },
}
</script>
